import { Box, CircularProgress, type SxProps, type Theme } from "@mui/material";
import {
  StackedDrawerShell,
  type StackedDrawerProps,
} from "shared-ui/src/components/detail-drawer/drawer-stack";

type RoutedDrawerLoadingProps = Pick<
  StackedDrawerProps,
  "open" | "onClose" | "onCloseAll" | "zIndex" | "depth"
> & {
  label: string;
  paperSx?: SxProps<Theme>;
};

/** Placeholder a routed drawer shows while it resolves its URL id after a refresh. */
export function RoutedDrawerLoading({
  label,
  paperSx,
  ...shellProps
}: RoutedDrawerLoadingProps) {
  return (
    <StackedDrawerShell {...shellProps} ariaLabel={label} paperSx={paperSx}>
      <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
        <CircularProgress aria-label={label} />
      </Box>
    </StackedDrawerShell>
  );
}
